"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
const autobind_decorator_1 = require("autobind-decorator");
const React = require("react");
const CruxComponent_1 = require("../CruxComponent");
let IterableNestedComponent = class IterableNestedComponent extends React.Component {
    constructor(props) {
        super(props);
        this.collapseNestedToggle = () => {
            this.props.collapseNestedToggle(this.props.index);
        };
        this.showIterableButtons = () => {
            this.setState({ showIterableButton: true });
        };
        this.hideIterableButtons = () => {
            this.setState({ showIterableButton: false });
        };
        this.addAtIndex = () => {
            this.props.addAtIndex(this.props.index);
        };
        this.reorder = (event) => {
            this.props.reorder(this.props.index, Number(event.target.getAttribute("data-value")));
        };
        this.remove = () => {
            this.props.remove(this.props.index);
        };
        this.customButtonAction = () => {
            this.props.field.additionalButtons.customButtonAction(this.props.currentModel);
        };
        this.iterableButtons = () => {
            if (!this.props.readonly) {
                const iterableButtonStyle = { marginLeft: "10px", color: "grey", cursor: "pointer" };
                const visibility = this.state.showIterableButton ? "visible" : "hidden";
                return (React.createElement("span", { style: { visibility } },
                    this.props.field.additionalButtons &&
                        React.createElement(React.Fragment, null,
                            this.props.field.additionalButtons.addAtIndex &&
                                React.createElement("span", { style: iterableButtonStyle, className: "glyphicon glyphicon-plus", "aria-hidden": "true", onClick: this.addAtIndex }),
                            this.props.field.additionalButtons.reorder && this.props.index != 0 &&
                                React.createElement("span", { style: iterableButtonStyle, "data-value": 0, className: "glyphicon glyphicon-chevron-up", "aria-hidden": "true", onClick: this.reorder }),
                            this.props.field.additionalButtons.reorder && this.props.index != this.props.totalLength - 1 &&
                                React.createElement("span", { style: iterableButtonStyle, "data-value": 1, className: "glyphicon glyphicon-chevron-down", "aria-hidden": "true", onClick: this.reorder }),
                            this.props.field.additionalButtons.customButton &&
                                React.createElement("span", { style: iterableButtonStyle, className: "glyphicon glyphicon-eye-open", "aria-hidden": "true", onClick: this.customButtonAction })),
                    React.createElement("span", { style: iterableButtonStyle, className: "glyphicon glyphicon-remove-circle", "aria-hidden": "true", onClick: this.remove })));
            }
            return null;
        };
        this.state = { showIterableButton: false };
    }
    render() {
        const titleStyle = { fontSize: "14px", fontWeight: "bold", marginBottom: "10px", color: "black", display: "flex" };
        if (this.props.field.iterabletype.nestedIterableCollapse) {
            titleStyle["cursor"] = "pointer";
        }
        return React.createElement("div", { key: this.props.index, style: this.props.field.iterabletype.style && this.props.field.iterabletype.style.border === "none" ? {} : {
                border: "1px solid #EEE",
                padding: "10px",
                marginTop: "10px"
            }, onMouseEnter: this.showIterableButtons, onMouseLeave: this.hideIterableButtons },
            this.props.field.iterabletype.nestedIterableCollapse && this.props.field.iterabletype.nestedIterableCollapse.title &&
                React.createElement("div", { onClick: this.collapseNestedToggle, style: titleStyle },
                    React.createElement("div", { style: { display: "inline-block", width: "90%" } }, this.props.getIterableNestedTitle(this.props.index)),
                    !this.props.collapsable &&
                        React.createElement("span", { style: { marginLeft: "10px", color: "grey", cursor: "pointer" }, className: "glyphicon glyphicon-chevron-up", "aria-hidden": "true" }),
                    this.props.collapsable &&
                        React.createElement("span", { style: { marginLeft: "10px", color: "grey", cursor: "pointer" }, className: "glyphicon glyphicon-chevron-down", "aria-hidden": "true" })),
            React.createElement("div", { style: { display: "inline-block" } }, !this.props.collapsable &&
                React.createElement(CruxComponent_1.NestedEditComponent, { index: this.props.index, readonly: this.props.readonly, currentModel: this.props.currentModel, fetch: this.props.fetch, field: this.props.field.iterabletype, additionalModels: this.props.additionalModels, nestedIterableModelChanged: this.props.modelChanged, modelChanged: this.props.modelChanged, showTitle: false, indent: false, iterableNested: true, modalType: this.props.modalType, parentModel: this.props.parentModel })),
            this.iterableButtons());
    }
};
IterableNestedComponent = __decorate([
    autobind_decorator_1.default
], IterableNestedComponent);
exports.IterableNestedComponent = IterableNestedComponent;
//# sourceMappingURL=IterableNestedComponent.js.map